import React, { useEffect, useContext, useState, useMemo } from 'react';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import { AccountContext } from 'components/AccountContext';
import { Box, Flex, Text, Button, Image, useDisclosure } from '@chakra-ui/react';
import EditarCartao from '../../../images/EditarCartao.svg';
import RetirarCartao from '../../../images/RetirarCartao.svg';
import ExcluirCartao from '../../../images/ExcluirCartao.svg';
import DrawerExcluirCartao from './DrawerExcluirCartao';
import useModelCartao from './useModelCartao';

function DetalhesCartao() {
  const { setPage, user } = useContext(AccountContext);
  const state = useLocation();
  const { card, themeApp } = state?.state;
  const drawer = useDisclosure();
  const navigate = useNavigate();
  const { definirCartaoPrincipal } = useModelCartao({ paciente_cartao_credito_pagarme_id: card.paciente_cartao_credito_pagarme_id });
  useEffect(() => {
    setPage('Cartões');
  }, [setPage]);

  return (
    <>
      <DrawerExcluirCartao disclosure={drawer} theme={themeApp} card={card} />
      <ChildHeader />
      <Box>
        <Flex m={8} mb={2} justify="center">
          <Box bg={themeApp?.background} borderRadius="1em" p={6} boxShadow="xl" w="100%" maxW="400px" color="white">
            <Flex justify="space-between" align="center" mb={6}>
              <Box bg="white" borderRadius="1em" boxSize="60px" />
            </Flex>
            <Box mt="8">
              <Text fontSize="lg" fontWeight="bold">
                {card.holder_name}
              </Text>
              <Text fontSize="sm" letterSpacing="wide">
                {card.first_digits} XXXX XXXX {card.last_digits}
              </Text>
            </Box>
          </Box>
        </Flex>

        <Flex m={8} mt={0} justify="center">
          <Box w="100%" maxW="400px">
            <Flex direction="column" align="flex-start" gap={2} mt={'5%'}>
              <Text color="#585858" fontWeight="bold">
                Opções
              </Text>

              <Box
                w="100%"
                borderBottom="1px solid"
                borderBottomColor="#EBEBEB"
                onClick={() =>
                  navigate('/perfil/pagamento/cadastro-cartao', {
                    state: {
                      themeApp,
                      card,
                      editar: true
                    },
                  })
                }
              >
                <Flex align="center" gap={2} py={2}>
                  <Image src={EditarCartao} />
                  <Text color="#585858">Editar cartão de crédito</Text>
                </Flex>
              </Box>

              {!card.default ? (
                <>
                  <Box w="100%" borderBottom="1px solid" borderBottomColor="#EBEBEB" onClick={() => definirCartaoPrincipal()}>
                    <Flex align="center" gap={2} py={2}>
                      <Image src={RetirarCartao} />
                      <Text color="#585858">Definir como cartão principal</Text>
                    </Flex>
                  </Box>
                </>
              ) : null}

              <Box w="100%" borderBottom="1px solid" borderBottomColor="#EBEBEB" onClick={() => drawer.onOpen()}>
                <Flex align="center" gap={2} py={2}>
                  <Image src={ExcluirCartao} />
                  <Text color="#585858">Excluir cartão</Text>
                </Flex>
              </Box>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
}

export default DetalhesCartao;
